import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleEntry() {
  const featuredArticles = articles.slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-14">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
              SEO Guides & Resources
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
              Superbuy Spreadsheet Knowledge Hub
            </h2>
          </div>
          <p className="mt-3 md:mt-0 text-sm text-foreground-500 max-w-md">
            Expert-written guides covering every aspect of using spreadsheets for smarter product research and purchasing
          </p>
        </div>

        {/* Featured large card */}
        <Link
          to="/superbuy-spreadsheet-guide"
          className="block bg-accent-500 rounded-2xl p-6 md:p-8 mb-8 hover:bg-accent-600 transition-colors cursor-pointer group"
        >
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
            <div className="lg:max-w-2xl">
              <div className="flex items-center gap-3 mb-4">
                <span className="px-3 py-1 rounded-full bg-background-50/20 text-background-50/90 text-xs font-medium">
                  Featured Guide
                </span>
                <span className="text-xs text-background-50/60 flex items-center gap-1">
                  <i className="ri-time-line"></i> 15 min read
                </span>
              </div>
              <h3 className="font-heading text-xl md:text-2xl text-background-50 font-semibold leading-relaxed mb-3">
                Superbuy Spreadsheet Complete Guide 2026
              </h3>
              <p className="text-sm text-background-50/75 leading-relaxed">
                The most comprehensive resource for mastering Superbuy Spreadsheet. From setting up your first spreadsheet to advanced techniques, this guide covers every step in detail.
              </p>
            </div>
            <span className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-background-50/15 text-background-50 text-sm font-medium group-hover:bg-background-50/25 transition-colors whitespace-nowrap self-start lg:self-center">
              Read Full Guide
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </div>
        </Link>

        {/* Article grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={article.heroImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-semibold text-sm md:text-base text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 mb-3">
                  {article.description}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {article.readTime}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i> July 2026
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* View all link */}
        <div className="text-center mt-8">
          <p className="text-sm text-foreground-500">
            Explore all {articles.length + 1} guides on the{' '}
            <Link to="/" className="text-primary-600 font-medium hover:underline">
              Superbuy Spreadsheet Hub
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
}